module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Eingang2.7f90914b.jpg";